import { RotateCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { WorkspaceVisualIdentity } from '@/features/workspace/types';
import { useWebinarT } from '@/hooks/useWebinarT';
import { getReadableTextColor } from '@/utils/colors';

/** Remplace la vidéo une fois le test terminé, là où le vrai spectateur part sur la page de fin. */
export default function EvergreenTestEndCard({
  visualIdentity,
  onRestart,
}: {
  visualIdentity: WorkspaceVisualIdentity;
  onRestart: () => void;
}) {
  const { t } = useWebinarT('webinars');
  const background = visualIdentity.backgroundColor ?? '#FFFFFF';

  return (
    <div
      className="w-full aspect-video lg:h-full flex flex-col items-center justify-center gap-4 rounded-none lg:rounded-2xl px-6 text-center"
      style={{ backgroundColor: background, color: getReadableTextColor(background) }}
    >
      <p className="text-xl md:text-2xl font-bold">{t('evergreenTest.endTitle')}</p>
      <p className="text-sm md:text-base opacity-80">{t('evergreenTest.endDescription')}</p>
      <Button
        type="button"
        onClick={onRestart}
        className="bg-button-primary hover:bg-button-primary/90 text-dark font-semibold px-8 py-6 rounded-full shadow-lg"
      >
        <RotateCw className="size-4" aria-hidden />
        {t('evergreenTest.restart')}
      </Button>
    </div>
  );
}
